<template>
    <div class="app app-v2">

        <AppHeader fixed>
            <NavigationBar :list-route="list" :obj="contract" :label="'contract_name'" :list-search="contracts" :search="searchContract" :input="selectContract" :placeholder="'Contract Selector'"></NavigationBar>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <div class="sidebar-info">
                    <router-link to="/settings/profile" class="title">
                        <h4 class="title">Hello {{user.name}}</h4>
                    </router-link>
                    <p class="content">
                        <router-link to="/settings/profile" class="title">
                        <span class="content-mail">{{user.email}}</span>
                        </router-link>
                        <span class="btn-logout" @click="logout">Logout</span>
                    </p>
                </div>
                <SidebarNav :navItems="nav"></SidebarNav>
                <SidebarFooter/>
            </AppSidebar>
            <GofixMainElement/>
            <AppAside fixed>
                <DefaultAside/>
            </AppAside>
        </div>
    </div>
</template>
<script>
    import nav from '@/_nav-settings'
    import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter } from '@coreui/vue'
    const Breadcrumb = () => import('../views/breadcrumb/Breadcrumb')
    const NavigationBar = () => import('../views/partial/NavigationBar')
    const DefaultAside = () => import('./DefaultAside')
    import { floatLabel } from '@/_floatLableClass.js'
    import { mapGetters } from 'vuex';
    const GofixMainElement = () => import('./GofixMainElement')

    export default {
        name: 'default-container-v2',
        components: {
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultAside,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            NavigationBar,
            GofixMainElement
        },
        data() {
            return {
                nav: nav.items,
                contracts: [],
                contract: {
                    data: null
                }
            }
        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => (route.meta.label))
            },
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                ListClientContract: 'ContractController/ListClientContract',
                contractDropdown: 'ContractController/contractDropdown',
                user : 'AuthController/user'
            }),
        },
        watch: {
            user: function(val){
                if(val.is_super){
                    this.nav = nav.items;//.concat(nav.supper);
                    this.nav[this.nav.length - 1].children.push(
                        {
                            name: 'Reference Table',
                            url: '/settings/reference-table',
                            icon: 'icon-arrow-right',
                        },
                    );
                }else{
                    this.nav = nav.items;
                }

                for(let i = 0; i < this.nav.length; i++){
                    if(this.nav[i].children){
                        this.nav[i].children = this.nav[i].children.filter((item)=>{
                            let access = true
                            if(item.roles){
                                if(!this.$checkRole(this.$accessModule[item.roles.access], item.roles.action)){
                                    access = false;
                                }
                            }
                            return access
                        })
                    }
                }



            },
            ListClientContract: function(val, old) {
                if(val && val.total && val.total != this.contractDropdown.total) {
                    this.search()
                }
            },
            ClientContractID: function(val, old) {
                this.contract.data = val
                if (val && old && val.id != old.id) {
                    let path = this.$route.path.split("/");
                    if(path.length >= 3) {
                        path[3] = val.id;
                    }

                    if(this.$route.path.includes('contract-client')) {
                        if(path[3] !=  this.$route.params.id) {
                            this.$router.push({ path: path.join('/') })
                        }
                    }
                }
                if(!val || !old || (val && old && val.id && old.id && val.id != old.id)){
                    var sorExpand = localStorage.getItem('sorExpand');
                    var sorSelected = localStorage.getItem('sorSelected');
                    if(sorExpand){
                        localStorage.removeItem('sorExpand');
                    }
                    if(sorSelected){
                        localStorage.removeItem('sorSelected');
                    }
	            }
                if(val){
                    let contractSelected = this.contracts.find(obj => obj.id == val.id )
                    if(!contractSelected)
                        this.contracts.push(val);
                }
                localStorage.setItem("ClientContractID", JSON.stringify(val));
            },
        },
        mounted: async function() {
            const el = document.body;
            el.classList.add('default-minimized');
            await this.$nextTick()
            this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
                floatLabel()
            })
            let li = document.querySelectorAll(".sidebar .nav-item.nav-dropdown"), i;
            for (i = 0; i < li.length; ++i) {
                li[i].classList.remove("open");
            }
        },
        updated: async function() {
            await this.$nextTick()
            floatLabel()
        },
        async created() {
            // this.$store.dispatch('AuthController/getUser')
            //     .then(result => {
            //         //fix #806
            //         // this.$store.dispatch('AuthController/getColumnSettingsUser', result.data.data.id)
            //     })
            //     .catch(error => {
            //         return this.logout()
            //     })
            if(this.$route.path.includes('contract-client')) {
                if (this.$route.params.hasOwnProperty('id') && !isNaN(this.$route.params.id)) {
                    this.$store.dispatch( 'ContractController/getClientContractID', this.$route.params.id)
                        .catch(error => {
                            if(this.$route.path.includes('contract-client')) {
                                return this.$router.push(`/v2/contract-client`)
                            }
                        })
                }
            }else{
                var item = localStorage.getItem("ClientContractID");
                if(item) this.selectContract(JSON.parse(item));
            }
            this.search()
        },
        methods: {
            async logout() {
                if(goFix){
                    await  goFix._logout();
                }else{
                    this.$store.dispatch('AuthController/logout')
                        .then(result => {
                            this.$store.reset();
                            this.$router.push(`/login`)
                        })
                        .catch(error => {
                            this.$router.push(`/login`)
                        })
                }
                localStorage.clear();
            },
            search(method = 'getListClientContractsSearch', filter = null, limit = 100) {
                this.$store.dispatch(`ContractController/${method}`, [1, filter, limit])
                    .then(response => {
                        this.contracts = response.data;
                    })
            },
            async searchContract(search, loading) {
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.search('getListClientContractsSearch', { contract_name: search })
                    loading(false);
                }, 500);
            },
            selectContract(item) {
                this.updateStore(item);
                this.$store.commit('ContractController/setClientContractID', item)
            },
            updateStore(item){
                if(item && item.id != undefined) {
                    this.$store.dispatch( 'ContractController/getClientContractID', item.id);
                    this.$store.commit('v2UserController/setListingUser', { items : [], total : 0, pages : { limit : 25, }})
                }
            }
        },
    }
</script>
